import React, {createRef, useState, useContext, useEffect} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import {makeStyles} from "@material-ui/core/styles";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';

import SystemContext from "../../../../SystemContext";
import {CheckboxEditor, MaskedNumber, MaskedTime} from "../../../../controls";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import TimeTableValidator from "../../validators/TimeTableValidator";
import { Checkbox, useTheme } from '@material-ui/core';
import ComboFormStyles from "../../styles/ComboFormStyles.js";


const TimeTable = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  const classes = makeStyles(ComboFormStyles)();

  useEffect(()=> {
    const handleAddRecord = ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    };

    if (eventBus) {
      eventBus.bind('Combos.CateringMeal.AddRecord', handleAddRecord);
      return () => {
        eventBus.unbind('Combos.CateringMeal.AddRecord', handleAddRecord);
      }
    }  
  }, [eventBus, tableRef])

  const props = {
    ..._props
  }

  const {comboRecord} = props;

  const records = comboRecord.records || [];

  const [state, setState] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  if (props.canEdit !== state.canEdit) {
    setState({...state, canEdit: props.canEdit});
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(TimeTableValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(150,2,undefined,undefined,undefined,undefined,false),
        title: "From Local Time",
        field: "fromLocalTime",
        emptyValue: 0,
        defaultValue: 0,
        editComponent: (props) => (
          <MaskedTime
            value={props.value}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (<span>{rowData.fromLocalTime}</span>),
      },
      {
        ...baseColumn,
        ...ColumnWidth(150,2,undefined,undefined,undefined,undefined,false),
        title: "To Local Time",
        field: "toLocalTime",
        emptyValue: 0,
        defaultValue: 0,
        editComponent: (props) => (
          <MaskedTime
            value={props.value}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (<span>{rowData.toLocalTime}</span>),
      },
    ];
  };

  const bodyRef = createRef();

  return (isAuthenticated &&
    <div className={classes.TimeTable}>
      <MaterialTable
        tableRef={tableRef}
        data={records}
        style={{
          backgroundColor: "#fdfdfd",
          boxShadow: "none",
          border: "2px solid #aaaaaa",
          borderRadius: 0,
        }}
        options={{
          actionsColumnIndex: -1,
          search: false,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.childTableHeader.backgroundColor,
            color: theme.palette.childTableHeader.textColor,
            padding: "2px",
          },
          toolbarButtonAlignment: "right",
          detailPanelType: "single",
          showTitle: false,
          toolbar: false,
          padding: 'dense',
          paging: false,
          filtering: false,
          draggable: false,
        }}
        components={{
          ...defaultComponents,
          Body: (props) => (
            <MaterialTableBody
              {...props}
              ref={bodyRef}
              rowHeight={46}
              overscanRowCount={10}
              addVirtualScrolling={true}
              bodyHeight={250}
              headerHeight={46}
            />
          ),
          Row: (props) => (
            <MaterialTableBodyRow {...props} />
          ),
        }}
        title="Duration"
        columns={getColumns({...props, canEdit: state.canEdit})}
        actions={[
        ]}
        editable={{
          isEditable: () => {
            return state.canEdit;
          },
          isDeletable: () => {
            return state.canEdit;
          },
          onRowAdd: state.canEdit
              ? (newData) => new Promise((resolve, reject) => {
                if (Array.isArray(records)) {
                  records.push({...__.omit(newData, ["isValid","errorMessage"])});
                  props.onChange({record: {...comboRecord, records}, oldRecord: comboRecord, resolve, reject});
                } else {
                  reject();
                }
              })
              : undefined,
          onRowUpdate: state.canEdit
              ? (newData, oldData) => new Promise((resolve, reject) => {
                  const idx = __.findIndex(records, {fromLocalTime: oldData.fromLocalTime});
                  if (idx >= 0) {
                    records[idx] = __.omit(newData, ["isValid","errorMessage"]);
                    props.onChange({record: {...comboRecord, records}, oldRecord: comboRecord, resolve, reject});
                  } else {
                    reject();
                  }
                })
              : undefined,
          onRowDelete: state.canEdit
            ? (oldData) => new Promise((resolve, reject) => {
                const idx = __.findIndex(records, {fromLocalTime: oldData.fromLocalTime});
                if (idx >= 0) {
                  records.splice(idx, 1);
                  props.onChange({record: {...comboRecord, records}, oldRecord: comboRecord, resolve, reject});
                } else {
                  reject();
                }
              })
            : undefined,
        }}
      />
    </div>
  );
}

export default TimeTable;
